import React from "react";
import styled from 'styled-components';
import BrBrandNoRequestItem from './BrBrandNoRequestItem'
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBrandNoAction, getBrandNoAddAction } from '../../modules/common/brandModule';
import LoadingOverlay from 'react-loading-overlay';
import {isMobileOnly} from 'react-device-detect';

const BrandAddViewBloc = styled.div`
    text-align: center;
`;

const BrandAddViewBtnBloc = styled.button`
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    display: ${props => props.display};//inline-block;
    border-radius: 4px;
`;

const BrandNoContainerBlock = styled.div`
    display: ${props => props.display};
`;

const BrandNoContainerUlBloc = styled.ul`
    
    ${isMobileOnly?"display:flex; flex-wrap:wrap; justify-content: space-between":"margin-left: -24px;"};
    
    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const BrandNoContainerNoItemBloc = styled.div`
    position: relative;
    height: 180px;
`;

const BrandNoContainerNoItemSpanBlock = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #666;
    font-size: 16px;
`;

const StyleLoader = styled(LoadingOverlay)`
//width: 250px;
//  height: 400px;
//  overflow: scroll;

    padding:0px;
    margin : 0px;
    //margin-top: -30px;
  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.1);
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;

const BRAND_NO_OFFSET = 10;

const BrBrandNoContainer = () => {

    const dispatch = useDispatch();
    const [offset, setOffset] = useState(0);
    const [addView, setAddView] = useState(false);
    const [scrollPostion, setScrollPostion] = useState({ heignt: 0, isClick: false });

    const { error, loading, brandNoItem } = useSelector(
        ({ brandItemsReducer, loadingReducer }) => ({
            error: brandItemsReducer.error,
            loading: loadingReducer['brand/NO'],
            brandNoItem: brandItemsReducer.brandNoItem,
        })
    );

    useEffect(() => {

        dispatch(getBrandNoAction("0"));
        setOffset(0);

        return () => {
            // console.log( "BrBrandNoContainer end = ");
        };

    }, [dispatch]);


    useEffect(() => {

        if (scrollPostion.heignt > 0 && scrollPostion.isClick) {
            window.scrollTo(0, scrollPostion.heignt);
        }

        if (brandNoItem != null) {
            if ((offset + BRAND_NO_OFFSET) <= brandNoItem.length) {
                setAddView(true);
            }
            else {
                setAddView(false);
            }
        }

        setScrollPostion({ heignt: 0, isClick: false });

        return () => {
            // console.log( "BrBrandNoContainer end = ");
        };

    }, [brandNoItem, offset]);

    const onClickAddView = () => {
        let count = offset + BRAND_NO_OFFSET;
        dispatch(getBrandNoAddAction(count.toString()));
        setOffset(count);
        setScrollPostion({ heignt: window.scrollY, isClick: true });
    }

    const getNoItemBlock = () => {
        // console.log("getNoItemBlock");
        return (
            <BrandNoContainerNoItemBloc>
                <BrandNoContainerNoItemSpanBlock>
                    현재 오픈 진행중인 브랜드가 없습니다.
                </BrandNoContainerNoItemSpanBlock>
            </BrandNoContainerNoItemBloc>
        );
    }

    if (error !== null && error !== undefined && brandNoItem === null) {
        // console.log("err = "+error)
        return <BrandNoContainerBlock>오류발생</BrandNoContainerBlock>
    }

    if (brandNoItem !== null && brandNoItem.length === 0) {
        return getNoItemBlock()
    }

    if (brandNoItem === null) {
        return <BrandNoContainerBlock></BrandNoContainerBlock>
    }

    return (
        <BrandNoContainerBlock>
            <StyleLoader
                active={loading}
                //active = "true"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                <BrandNoContainerUlBloc>
                    {
                        brandNoItem.map((item) => {

                            return (
                                <BrBrandNoRequestItem key={item.id.toString()} brandname={item.no_brnd_han ? item.no_brnd_han : item.no_brand_eng}
                                    requestStatus={0} img={item.no_brnd_logo_url} idHome={item.id} brandinfo={item.no_brnd_info_brief} />
                            )
                        })
                    }
                    {isMobileOnly ? <div style={{height:'0px', margin: '0px', width:'44vw'}}></div> : ''}
                </BrandNoContainerUlBloc>
                <BrandAddViewBloc>
                    <BrandAddViewBtnBloc display={addView ? 'inline-block' : "none"} onClick={onClickAddView}>
                        더보기
                    </BrandAddViewBtnBloc>
                </BrandAddViewBloc>
            </StyleLoader>
        </BrandNoContainerBlock>
    );
};

export default BrBrandNoContainer;
